const AC_API_URL: string = process.env.VUE_APP_ADMIN_CONSOLE_API_URL + "/";

export const AUTH_API_URLS = {
  SIGN_IN: `${AC_API_URL}auth/login`,
  SIGN_OUT: `${AC_API_URL}auth/logout`,
};

export const ADMIN_ACCOUNTS_API_URLS = (
  adminAccountId?: string
): Record<string, string> => {
  return {
    GET: `${AC_API_URL}admin-accounts/${adminAccountId}`,
    GET_CATALOG_AND_PRICING: `${AC_API_URL}admin-accounts/${adminAccountId}/catalog-and-pricings`,
    STORE_DEFAULT_PRICING: `${AC_API_URL}admin-accounts/${adminAccountId}/default-pricing`,
    UPDATE: `${AC_API_URL}admin-accounts/${adminAccountId}`,
    UPDATE_API_KEY: `${AC_API_URL}admin-accounts/${adminAccountId}/api-key`,
  };
};

export const DEVICES_API_URLS = (): Record<string, string> => {
  return {
    DOWNLOAD_SUPPORTED_DEVICES: `${AC_API_URL}devices/download-supported-devices`,
  };
};

export const DOCUMENTS_API_URLS = (): Record<string, string> => {
  return {
    UPLOAD_DOCUMENT: `${AC_API_URL}document-files/upload`,
  };
};

export const UTILITIES_API_URLS = {
  LOG: `${AC_API_URL}log`,
};

export const REPORTS_API_URLS = {
  DOWNLOAD_CSV_REPORT: `${AC_API_URL}reports/download-csv`,
  DOWNLOAD_XLSX_REPORT: `${AC_API_URL}reports/download-xlsx`,
  REPORTS: `${AC_API_URL}reports`,
  REPORT_FIELDS: `${AC_API_URL}reports/fields`,
  EMBED_REPORT: `${AC_API_URL}reports/embed-report`,
};

export const MERCHANTS_API_URLS = (
  merchantId?: number
): Record<string, string> => {
  return {
    GET_MERCHANTS: `${AC_API_URL}merchants`,
    UPDATE_MERCHANT: `${AC_API_URL}merchants/${merchantId}`,
    UPDATE_MERCHANT_FLAGS_CLOSED: `${AC_API_URL}merchants/${merchantId}/merchant-flags/closed`,
    UPDATE_STORE_PAYMENT: `${AC_API_URL}merchants/${merchantId}/merchant-flags/in-store-payments`,
    STORE_MERCHANT: `${AC_API_URL}merchants`,
  };
};

export const CLERKS_API_URLS = (
  clerkId?: number,
  uuid?: string
): Record<string, string> => {
  return {
    GET_CLERKS: `${AC_API_URL}clerks`,
    UPDATE_STATUS: `${AC_API_URL}clerks/${clerkId}/status`,
    UPDATE_PERSON_STATUS: `${AC_API_URL}clerks/${uuid}/person-status`,
    STORE_CLERK: `${AC_API_URL}clerks`,
  };
};

export const BILLING_PORTAL_API_URLS = {
  SEARCH_STATEMENTS: `${AC_API_URL}admin-settlement-statement`,
  DOWNLOAD_STATEMENTS: `${AC_API_URL}admin-settlement-statement/download`,
};
